import { useQuery } from "@tanstack/react-query";
import {
  completes,
  noBarData,
  noData,
  type PerformanceWithAccountFilter,
  starts,
} from "features/Library/Common/utils/performanceUtils";
import { reportingColors } from "features/Library/Common/utils/constants";
import { ChartWrapper, HorizontalBarChart } from "components/charts";
import { RequestStatusRenderer } from "components/requestStatsRenderer/RequestStatusRenderer";
import CardReporting from "components/cards/CardReporting/CardReporting";
import { sharedAccountReportingHorizontalBarProps } from "features/Reporting/Content/shared";
import { getTemplateFlowEngagementChart } from "./queries";
import styles from "./templateFlowEngagement.module.scss";

export interface Props {
  templateId: number;
  filter: PerformanceWithAccountFilter;
}

export const TemplateFlowEngagement: React.FC<Props> = ({ templateId, filter }) => {
  const flowEngagementChartQuery = useQuery({
    queryKey: ["templateFlowEngagementChart", templateId, filter],
    queryFn: getTemplateFlowEngagementChart,
    enabled: filter.type !== undefined,
  });

  return (
    <div className={styles.contentReport}>
      <div className={styles.activity}>
        <ChartWrapper
          titles={["Flow Engagement"]}
          legendLabels={[starts, completes]}
          showLegend
          colorRange={[reportingColors.blue, reportingColors.yellow]}
        >
          <RequestStatusRenderer state={flowEngagementChartQuery.status}>
            {flowEngagementChartQuery.isSuccess &&
            flowEngagementChartQuery.data.barData &&
            !noBarData(...flowEngagementChartQuery.data.barData.map((d) => d.value)) ? (
              <HorizontalBarChart
                {...sharedAccountReportingHorizontalBarProps}
                data={flowEngagementChartQuery.data.barData}
              />
            ) : (
              noData(filter)
            )}
          </RequestStatusRenderer>
        </ChartWrapper>
      </div>
      <div className={styles.cards}>
        <RequestStatusRenderer state={flowEngagementChartQuery.status}>
          {flowEngagementChartQuery.isSuccess && flowEngagementChartQuery.data.cards && (
            <CardReporting items={flowEngagementChartQuery.data.cards} columnCount={3} />
          )}
        </RequestStatusRenderer>
      </div>
    </div>
  );
};

export default TemplateFlowEngagement;
